webpackJsonp([7],{

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ncaa_vendor__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__memberList_datatable__ = __webpack_require__(832);






var DATATABLE_SELECTOR = '#memberListTable';

function bootstrapPage(typeId, division, state, sportCode, typeDescription) {
  sessionStorage.setItem('listType', typeId);
  sessionStorage.setItem('listDescription', typeDescription);

  new __WEBPACK_IMPORTED_MODULE_2__memberList_datatable__["a" /* default */](DATATABLE_SELECTOR, typeId, division, state, sportCode);
}

document.addEventListener('DOMContentLoaded', function () {
  var typeId = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#typeId').val());
  var division = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#division').val();
  var state = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#state').val();
  var sportCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sportCode').val();
  var typeDescription = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#typeDescription').val();

  bootstrapPage(typeId, division, state, sportCode, typeDescription);
});

/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__endpoints_DirectoryService__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DirectoryDataTableHelper__ = __webpack_require__(833);








function createDataTable(selector, typeId, division, state, sportCode) {
  var params = '?type=' + typeId;
  if (division) params += '&division=' + division;
  if (state) params += '&state=' + state;
  if (sportCode) params += '&sportCode=' + sportCode;

  var dataTable = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(selector).DataTable({
    ajax: { url: __WEBPACK_IMPORTED_MODULE_3__endpoints_DirectoryService__["a" /* default */].getMemberListApiEndPoint() + params, dataSrc: '' },
    responsive: true,
    autoWidth: false,
    pageLength: 25,
    columns: __WEBPACK_IMPORTED_MODULE_4__DirectoryDataTableHelper__["a" /* default */].defineColumns(typeId, sportCode),
    order: __WEBPACK_IMPORTED_MODULE_4__DirectoryDataTableHelper__["a" /* default */].defineOrder(typeId),
    'language': {
      'emptyTable': 'No members found'
    }
  });

  return dataTable;
}

var MemberListTable = function () {
  function MemberListTable(tableSelector, typeId, division, state, sportCode) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MemberListTable);

    this.tableSelector = tableSelector;
    this.typeId = typeId;
    this.division = division.length > 0 ? division : null;
    this.state = state.length > 0 ? state : null;
    this.sportCode = sportCode.length > 0 ? sportCode : null;
    this.initialize();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MemberListTable, [{
    key: 'initialize',
    value: function initialize() {
      createDataTable(this.tableSelector, this.typeId, this.division, this.state, this.sportCode);
    }
  }]);

  return MemberListTable;
}();

/* harmony default export */ __webpack_exports__["a"] = (MemberListTable);

/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__ = __webpack_require__(38);


'use strict';

var FIELDS = {
  ORG_ID: 'orgId',
  ORG_NAME: 'nameOfficial',
  CONFERENCE_ID: 'conferenceId',
  CONFERENCE_NAME: 'conferenceName',
  DIVISION: 'division',
  SUBDIVISION: 'subdivision',
  RECLASS_DIVISION: 'reclassDivision',
  RECLASS_SUBDIVISION: 'reclassSubdivision',
  STATE: 'memberOrgAddress.state',
  WEBSITE: 'webSiteUrl',
  ATHLETIC_WEBSITE: 'athleticWebUrl',
  SPORT_CONFERENCE_ID: 'sportConferenceId',
  SPORT_CONFERENCE_NAME: 'sportConferenceName',
  SPORT_DESCRIPTION: 'sportDescription',
  SPORT_REGION: 'sportRegion',
  PRIVATE_FLAG: 'privateFlag',
  HBCU_FLAG: 'historicallyBlackFlag'
};

var ORG_NAME_COLUMN = {
  data: FIELDS.ORG_NAME,
  title: 'Name',
  render: function render(data, type, row) {
    return renderOrgHyperlink(row[FIELDS.ORG_ID], row[FIELDS.ORG_NAME]);
  }
};

var CONFERENCE_COLUMN = {
  data: FIELDS.CONFERENCE_NAME,
  title: 'Conference',
  render: function render(data, type, row) {
    if (!row[FIELDS.CONFERENCE_NAME] || row[FIELDS.CONFERENCE_NAME] && row[FIELDS.CONFERENCE_NAME].length === 0) {
      return 'Independent';
    }
    return renderOrgHyperlink(row[FIELDS.CONFERENCE_ID], row[FIELDS.CONFERENCE_NAME]);
  }
};

var DIVISION_COLUMN = {
  data: FIELDS.DIVISION,
  title: 'Division',
  render: function render(data, type, row) {
    return __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderDivisionSubdivisionText(row[FIELDS.DIVISION], row[FIELDS.SUBDIVISION]);
  }
};

var DIVISION_ONLY_COLUMN = {
  data: FIELDS.DIVISION,
  title: 'Division',
  render: function render(data, type, row) {
    return __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderDivisionText(row[FIELDS.DIVISION]);
  }
};

var RECLASS_DIVISION_COLUMN = {
  data: FIELDS.RECLASS_DIVISION,
  title: 'Reclass Division',
  render: function render(data, type, row) {
    return __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderDivisionSubdivisionText(row[FIELDS.RECLASS_DIVISION], row[FIELDS.RECLASS_SUBDIVISION]);
  }
};

var STATE_COLUMN = {
  data: FIELDS.STATE,
  title: 'State'
};

var SPORT_COLUMN = {
  data: FIELDS.SPORT_DESCRIPTION,
  title: 'Sport'
};

var INSTITUTION_LINKS_COLUMN = {
  data: null,
  orderable: false,
  defaultContent: '',
  title: 'Links',
  render: function render(data, type, row) {
    var hyperlinks = '';

    if (row[FIELDS.WEBSITE]) {
      hyperlinks += __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderHyperlink(row[FIELDS.WEBSITE], 'glyphicons-education');
    }

    if (row[FIELDS.ATHLETIC_WEBSITE]) {
      if (hyperlinks.length > 0) hyperlinks += '<br/>';
      hyperlinks += __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderHyperlink(row[FIELDS.ATHLETIC_WEBSITE], 'glyphicons-rugby');
    }
    return hyperlinks;
  }
};

var NON_INSTITUTION_LINKS_COLUMN = {
  data: null,
  orderable: false,
  defaultContent: '',
  title: 'Links',
  render: function render(data, type, row) {
    var hyperlinks = '';

    if (row[FIELDS.WEBSITE]) {
      hyperlinks += __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderHyperlink(row[FIELDS.WEBSITE], null);
    }
    return hyperlinks;
  }
};

var SPORT_CONFERENCE_COLUMN = {
  data: FIELDS.SPORT_CONFERENCE_NAME,
  title: 'Sport Conference',
  render: function render(data, type, row) {
    if (!row[FIELDS.SPORT_CONFERENCE_NAME] || row[FIELDS.SPORT_CONFERENCE_NAME] && row[FIELDS.SPORT_CONFERENCE_NAME].length === 0) {
      return 'Independent';
    }
    return renderOrgHyperlink(row[FIELDS.SPORT_CONFERENCE_ID], row[FIELDS.SPORT_CONFERENCE_NAME]);
  }
};

var SPORT_REGION_COLUMN = {
  data: FIELDS.SPORT_REGION,
  title: 'Region',
  render: function render(data, type, row) {
    return __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderInitCap(data);
  }
};

var PRIVATE_FLAG_COLUMN = {
  data: FIELDS.PRIVATE_FLAG,
  title: 'Public/Private',
  render: function render(data, type, row) {
    return __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderPrivateFlagText(row[FIELDS.PRIVATE_FLAG]);
  }
};

var HBCU_FLAG_COLUMN = {
  data: FIELDS.HBCU_FLAG,
  title: 'HBCU',
  render: function render(data, type, row) {
    return __WEBPACK_IMPORTED_MODULE_0__common_DataTableHelper__["a" /* default */].renderYesNoText(row[FIELDS.HBCU_FLAG]);
  }
};

function defineColumns(typeId, sportCode) {
  var columns = [];

  switch (typeId) {
    case 1:
    case 2:
    case 10:
    case 11:
      columns = [ORG_NAME_COLUMN, CONFERENCE_COLUMN, DIVISION_COLUMN, STATE_COLUMN, INSTITUTION_LINKS_COLUMN];
      break;
    case 3:
      columns = [ORG_NAME_COLUMN, DIVISION_COLUMN, NON_INSTITUTION_LINKS_COLUMN];
      break;
    case 4:
      columns = [ORG_NAME_COLUMN, NON_INSTITUTION_LINKS_COLUMN];
      break;
    case 5:
      columns = [ORG_NAME_COLUMN, CONFERENCE_COLUMN, DIVISION_COLUMN, RECLASS_DIVISION_COLUMN, STATE_COLUMN, INSTITUTION_LINKS_COLUMN];
      break;
    case 6:
    case 7:
    case 8:
    case 9:
      columns = [ORG_NAME_COLUMN, SPORT_CONFERENCE_COLUMN, SPORT_COLUMN];
      break;
    case 12:
      if (sportCode) {
        columns = [ORG_NAME_COLUMN, CONFERENCE_COLUMN, DIVISION_COLUMN, RECLASS_DIVISION_COLUMN, PRIVATE_FLAG_COLUMN, HBCU_FLAG_COLUMN, STATE_COLUMN, SPORT_REGION_COLUMN];
      } else {
        columns = [ORG_NAME_COLUMN, CONFERENCE_COLUMN, DIVISION_COLUMN, RECLASS_DIVISION_COLUMN, PRIVATE_FLAG_COLUMN, HBCU_FLAG_COLUMN, STATE_COLUMN];
      }
      break;
    case 13:
    case 14:
    case 15:
      columns = [ORG_NAME_COLUMN, DIVISION_ONLY_COLUMN, STATE_COLUMN, NON_INSTITUTION_LINKS_COLUMN];
      break;
  }

  return columns;
}

function defineOrder(typeId) {
  if (typeId >= 6 && typeId <= 9) {
    return [[2, 'asc'], [0, 'asc']];
  } else {
    return [[0, 'asc']];
  }
}

function renderOrgHyperlink(orgId, orgName) {
  if (orgId && orgName) {
    return '<a href="orgDetail?id=' + orgId + '">' + orgName + '</a>';
  } else {
    return '';
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  defineColumns: defineColumns,
  defineOrder: defineOrder,
  renderOrgHyperlink: renderOrgHyperlink
});

/***/ })

},[831]);


// WEBPACK FOOTER //
// js/memberList-page.js